<template>
  <div style="position: relative;top:50px;right:50px;">
    <Vue3DraggableResizable
      :x="x"
      :y="y"
      :w="width"
      :h="height"
      :draggable="true"
      :resizable="true"
      @dragging="onDrag"
      @resizing="onResize"
    >
      <!-- Your content here -->
      <div><img src="images/home_round.png" width="100%" /></div>
    </Vue3DraggableResizable>
  </div>
</template>

<script>
import Vue3DraggableResizable from 'vue3-draggable-resizable';
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css';

export default {
  components: {
    Vue3DraggableResizable
  },
  data() {
    return {
      x: 200, // initial x position
      y: 200, // initial y position
      width: 500, // initial width
      height: 500, // initial height
    };
  },
  methods: {
    onDrag(newX, newY) {
      this.x = newX;
      this.y = newY;
    },
    onResize(newWidth, newHeight) {
      this.width = newWidth;
      this.height = newHeight;
    },
  },
};
</script>

<style scoped>
/* Add any additional styles for your component */
</style>
